export default __webpack_public_path__ + "static/media/wa_5.8bf690cb.mp3";